/* eslint-disable import/extensions */

import { DayPicker } from 'react-day-picker';
import 'react-day-picker/style.css';
import styled from 'styled-components';
import mainColors from '../../main-colors';

const CalendarWrapper = styled(DayPicker)`
  ${({ $typography }) =>
    `
  --rdp-accent-color: ${mainColors.main_color};
  --rdp-animation_duration: 0.6s;
  --rdp-day-height: 44px; /// default
  --rdp-day-width: 44px;
  --rdp-day_button-border-radius: 50px;
  --rdp-day_button-height: 42px;
  --rdp-day_button-width: 42px;
  --rdp-disabled-opacity: 0.3;
  --rdp-today-color: ${mainColors.text_color};
  --rdp-nav_button-disabled-opacity: 0.3;
  --rdp-nav-height: 44px; /// default
  --rdp-weekday-opacity: 0.8;
  --rdp-weekday-padding: 12px;
  --rdp-weekday-text-align: center;

  .rdp-day_button {
    -webkit-tap-highlight-color: transparent;
    &:focus-visible {
      outline: none;
    }
  }

  .rdp-caption_label,
  .rdp-weekday {
    text-transform: capitalize;
  }

  .rdp-caption_label,
  .rdp-weekday,
  .rdp-footer {
    font-weight: ${$typography.fontWeight};
    line-height: ${$typography.lineHeight};
    font-size: ${$typography.scale}em;
  }

  `}
`;

export default CalendarWrapper;
